import { render, staticRenderFns } from "./PopupZlatnik.vue?vue&type=template&id=ae31bb86&scoped=true&"
import script from "./PopupZlatnik.vue?vue&type=script&lang=js&"
export * from "./PopupZlatnik.vue?vue&type=script&lang=js&"
import style0 from "./PopupZlatnik.vue?vue&type=style&index=0&id=ae31bb86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ae31bb86",
  null
  
)

export default component.exports